import React from 'react';

const RepertoireReviews = () => {
  const performances = [
    {
      title: 'Swan Lake',
      review: '"A breathtaking triumph... a masterclass in classical ballet." - The Evergreen Critic',
      description: 'Our recent production of Swan Lake captivated audiences with its timeless story of love and tragedy, featuring stunning choreography and powerful performances by our principal dancers.',
      imageUrl: 'img/PNB.Angela-Generosa.Jonathan-Batista.Giselle.Photo-Lindsay-Thomas-GenerosaBatista_Feb22_LT_017-768x506.jpeg'
    },
    {
      title: 'The Nutcracker',
      review: '"A holiday spectacle for the entire family. Pure magic on stage." - Community Arts Journal',
      description: 'A beloved holiday tradition, our annual performance of The Nutcracker brings Clara\'s magical journey to life with enchanting sets, festive costumes, and Tchaikovsky\'s iconic score.',
      imageUrl: 'img/Review%20Pacific%20Northwest%20Ballet%20Plays%20With%20Limits%20and%20Dystopia%20at%20City%20Center.webp'
    },
    {
      title: 'Don Quixote',
      review: '"Vibrant, fiery, and full of life. A dazzling display of technical brilliance." - The Daily Chronicle',
      description: 'Set in a vibrant Spanish landscape, this energetic and comedic ballet tells the story of Don Quixote\'s adventures. Our production was celebrated for its spirited performances and colorful staging.',
      imageUrl: 'img/RobbinsB_1185_xru98u.webp'
    },
    {
      title: 'A Midsummer Night\'s Dream',
      review: '"Whimsical and wonderfully imaginative. A true delight." - The Arts Review',
      description: 'Shakespeare\'s classic comedy was transformed into a magical ballet, complete with mischievous fairies, mistaken lovers, and enchanting choreography that transported the audience to a mystical forest.',
      imageUrl: 'img/SBDress-0871-scaled-e1738638585445.jpg'
    },
  ];

  return (
    <div className="container-custom py-12">
      <h1 className="text-4xl font-bold font-elegant text-ballet-burgundy mb-4 text-center">Repertoire & Reviews</h1>
      <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
        Northwest Ballet Theater is proud to present a diverse repertoire of classical and contemporary works. Here is a selection of our past performances and the critical acclaim they received.
      </p>
      <div className="space-y-12">
        {performances.map((performance, index) => (
          <div key={index} className="flex flex-col md:flex-row items-center bg-white rounded-lg shadow-elegant overflow-hidden transform hover:shadow-xl transition-shadow duration-300">
            <div className="md:w-1/3">
              <img
                src={performance.imageUrl}
                alt={performance.title}
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="md:w-2/3 p-8">
              <h3 className="text-3xl font-elegant text-ballet-burgundy font-semibold mb-2">{performance.title}</h3>
              <blockquote className="text-lg italic text-gray-800 border-l-4 border-ballet-pink pl-4 mb-4">
                {performance.review}
              </blockquote>
              <p className="text-gray-700">{performance.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RepertoireReviews;
